import RouteUrls from './RouteUrls';

const SIDEBAR_STRUCTURE = {
    GROUP_1: {
        label: 'sidebar.menu.group_1.label',
        id: 'group1',
        groupItems: [
            {
                rootEntity: 'sidebar.menu.group_1.rootEntity.configuration',
                id: 'group1-config',
                items: [
                    RouteUrls.MERCHANT_ACCOUNTS,
                    RouteUrls.ORGANIZATIONS,
                    RouteUrls.USERS,
                    RouteUrls.PLANS,
                    RouteUrls.PUSH_PAYMENTS
                ]
            },
            {
                items: [
                    RouteUrls.SEARCH_CONTRACTS
                ]
            },
            {
                rootEntity: 'sidebar.menu.group_1.rootEntity.parc',
                id: 'group1-parc',
                items: [
                    RouteUrls.SUBSCRIPTIONS,
                    RouteUrls.SIM_CARDS
                ]
            },
            {
                rootEntity: 'sidebar.menu.group_1.rootEntity.exploitation',
                id: 'group1-exploitation',
                items: [
                    RouteUrls.REMOTE_COLLECTION,
                    RouteUrls.ENVELOPES
                ]
            },
            {
                items: [
                    RouteUrls.HISTORICS
                ]
            }
        ]
    },
    // Waiting for the documentation and newsletter to be implemented
    GROUP_2: {
        label: 'sidebar.menu.group_2.label',
        id: 'group2',
        groupItems: [
            {
                items: [
                    RouteUrls.DOCUMENTATION
                ]
            },
            {
                items: [
                    RouteUrls.NEWSLETTER
                ]
            }
        ]
    }
};

export default SIDEBAR_STRUCTURE;